import React from 'react';
import { Closest } from '../../utils/htmlnodes/Selectors';

export default class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ativo: false
    };

    this.handlerClick = this.handlerClick.bind(this);
  }

  handlerClick(e) {
    const item = Closest(e.currentTarget,'.box-pr');
    const classAtivo = 'ativo';

    if(this.state.ativo){
      item.classList.remove(classAtivo);
    } else {
      item.classList.add(classAtivo);
    }

    this.setState({
      ativo: !this.state.ativo
    });

    e.preventDefault();
  }

  render(){
    return(
      <div className='box-pr'>
        <a href='#' className='item-pr' onClick={this.handlerClick}>
          {this.props.data.pergunta}
          <i className="fas fa-chevron-down"></i>
        </a>
        <div className='item-pr-resposta animate'>
          <div className='item-pr-resposta__inner'>
            {this.props.data.resposta}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/perguntas/Item.js